
export const breakpointsConstants = {
    sm: 640, // large phones & small tablets
    md: 768, // Tablets
    lg: 1024, // Laptops & large tablets
    xl: 1280, // Desktop & large laptops
    "2xl": 1536 // Wide screen & large desktops
} as const;
